import { navItems } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-700 text-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold">丁香花影院</span>
            </div>
            <p className="text-secondary-300 text-sm leading-relaxed mb-4">
              丁香花影院是稳定可靠的在线影院平台，提供网络电视、电影网站级视频点播服务。追剧平台免费看高清电影电视剧，无需缓冲，随时随地享受观影乐趣。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-600 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-600 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-600 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {navItems.slice(1).map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold mb-4">影视分类</h3>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">热门电影</a></li>
              <li><a href="#cards" className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">电视剧全集</a></li>
              <li><a href="#cards" className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">综艺节目</a></li>
              <li><a href="#cards" className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">动漫番剧</a></li>
              <li><a href="#cards" className="text-secondary-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">纪录片</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold mb-4">合作伙伴</h3>
            <p className="text-secondary-300 text-sm leading-relaxed">
              感谢以下合作伙伴对丁香花影院的支持与信赖。期待更多优质伙伴加入，共同打造更好的观影平台。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-600 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-300 text-xs md:text-sm">
            &copy; 2021 - {new Date().getFullYear()} 丁香花影院 dingxianghua.cn 版权所有
          </p>
          <p className="text-secondary-400 text-xs">
            本站所有内容均来自互联网，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}